<template>
  <div>
    <el-upload class="upload"
               ref="upload"
               action=""
               :multiple="allowMultiple"
               accept=".pdf"
               :auto-upload="false"
               :show-file-list="false"
               :on-change="handleFileChange"
               style="float:none;">
      <el-button slot="trigger"
                 size="medium"
                 @click="clearUpload"
                 type="primary">{{selectTile}}{{allowMultiple?'(s)':''}}</el-button>
    </el-upload>
    <div class="select-pdf-button"
         v-show="this.fileData!==null">
      <label @click.stop.prevent="checkAll">
        <el-checkbox v-model="selectAll"
                     style="margin-bottom:10px;">{{$t('diagramDialog.SelectAll')}}</el-checkbox>
      </label>
      <multiselect v-model="pickPageList"
                   :options="options"
                   :multiple="true"
                   :close-on-select="false"
                   :clear-on-select="false"
                   :allow-empty="true"
                   :searchable="true"
                   :show-labels="false"
                   :limit="1"
                   :limit-text="limitText"
                   :show-no-results="false"
                   :placeholder="$t('diagramDialog.SearchPage')"
                   selectLabel=" "
                   deselectLabel=" "
                   track-by="key"
                   label="value"
                   @select=onMultiSelect($event)
                   @remove=onMultiRemove($event)
                   style="width:220px; display:inline-block; margin-left:15px">
        <template slot="selection"
                  slot-scope="{ values, isOpen }">
          <span class="multiselect__single"
                v-if="values.length && !isOpen">{{$t('diagramDialog.PagesSelected',[pickPageList.length])}}</span>
        </template>
        <span class="checkbox-label"
              slot="option"
              slot-scope="scope">
          <input class="test"
                 type="checkbox"
                 v-model="scope.option.checked"
                 @focus.prevent />
          {{ scope.option.value }}
        </span>
      </multiselect>
    </div>
    <div class="pdf-main-div"
         :style="{height:pdfDivHeight+'px'}">
      <div v-show="this.fileData!==null"
           id="pdfDialog"
           class="pdf-dialog">
        <div class="pdf-headers">
          <div size="mini"
               style="width: calc(100% - 35px);">
            <p class="pdf-headers-p">{{fileName}}</p>
          </div>
        </div>
        <div class="pdf-main"
             ref="scrollContainer"
             v-loading="loading">
          <div style="margin:0 auto"
               :style="{
        width: scale + '%'
      }">
            <div class="cube-box">
              <div class="pdf-page-box">
                <el-checkbox :label="pageTitle"
                             v-model="checkedPage">
                </el-checkbox>
                <div class="pdf-page-div"
                     :id="'pdfPage-'+pageNum"
                     @click="checkPageClick">
                  <pdf ref="pdf"
                       :src="fileData"
                       :page="pageIndex"
                       :rotate="pageRotate"
                       @progress="loadedRatio = $event"
                       @page-loaded="pageLoaded($event)"
                       @error="pdfError($event)"
                       @link-clicked="page = $event">
                  </pdf>
                  <!-- @num-pages="pdfTotalPage($event)" -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pdf-footers">
          <ul class="footer-ul">
            <li class="btnClass"
                :class="{select:idx==0}"
                @touchstart="idx=0"
                @touchend="idx=-1"
                @click="scaleD">
              <p class="more-p el-icon-zoom-in"></p>
            </li>
            <li class="btnClass"
                :class="{select:idx==1}"
                @touchstart="idx=1"
                @touchend="idx=-1"
                @click="scaleX">
              <p class="small-p el-icon-zoom-out"></p>
            </li>
            <li class="btnClass"
                :class="{select:idx==2}"
                @touchstart="idx=2"
                @touchend="idx=-1"
                @click="prePage()"
                id="btnPrePage">
              <p class="up-p el-icon-arrow-left"></p>
            </li>
            <li style="width:120px;">
              <div class="page-p"
                   style="margin-top:3px;">
                <div>
                  <input v-model.number="curPageNum"
                         size="mini"
                         :height="25"
                         @input="numberChange"
                         onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode)))'> / {{pageTotalNum}}
                </div>
              </div>
            </li>
            <li class="btnClass"
                :class="{select:idx==3}"
                @touchstart="idx=3"
                @touchend="idx=-1"
                @click="nextPage()"
                id="btnNextPage">
              <p class="down-p el-icon-arrow-right"></p>
            </li>
            <li class="btnClass"
                @click="rotateLeft()">
              <p class="more-p el-icon-refresh-left"></p>
            </li>
            <li class="btnClass"
                @click="rotateRight()">
              <p class="more-p el-icon-refresh-right"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pdf from 'vue-pdf'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  props: {
    allowMultiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      pdfList: [],
      selectTile: this.$t('diagramDialog.SelectPDF'),
      currentFile: null,
      fileData: null,
      fileName: null,
      pageNum: 1,
      pageIndex: 1,
      pageTotalNum: 0,
      pageRotate: 0,
      loadedRatio: 10, // 加载进度
      curPageNum: 1,
      idx: 0,
      scale: 90, // 放大系数
      dialogWidth: 1200,
      pdfDivHeight: 480,
      loading: false,
      pageCubeWidth: '50%',
      selectAll: true,
      options: [],
      checkedAll: true,
      pickPageList: []
    }
  },
  computed: {
    ...mapState(['jobsiteID']),
    checkedPage: {
      get () {
        return this.pickPageList.findIndex(p => p.index === this.pageNum) !== -1
      },
      set () {
        this.checkPageClick()
      }
    },
    pageTitle () {
      let curPage = this.options.find(q => q.index === this.pageNum)
      if (curPage) {
        let indexPage = curPage.key.split(',')
        return indexPage[1]
      } else return ''
    },
    checkPageList () {
      let copy = JSON.parse(JSON.stringify(this.pickPageList))
      copy.sort(function (a, b) {
        if (a.index > b.index) return 1
        if (a.index < b.index) return -1
        return 0
      })
      // let keyList = copy.map(q => { return q.key })
      let map = []
      for (let item of copy) {
        let key = item.key
        let indexPage = key.split(',')
        let fileIndex = parseInt(indexPage[0])
        let pageIndex = parseInt(indexPage[1])
        let rotation = item.rotation
        let existFile = map.findIndex(q => q.index === fileIndex) >= 0
        if (!existFile) {
          map.push({ index: fileIndex, file: this.pdfList[fileIndex].file, pages: [{ page: pageIndex, rotation: rotation }] })
        } else {
          map.find(q => q.index === fileIndex).pages.push({ page: pageIndex, rotation: rotation })
        }
      }
      return map
    }
  },
  created () {
  },
  mounted () {
    this.setDialogWidth()
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  watch: {
    checkPageList (to, from) {
      this.$emit('checkPageListChange', to)
    },
    pickPageList (to, from) {
      this.selectAll = this.pickPageList.length === this.options.length
    },
    checkedPage (to, from) {
      this.selectAll = this.pickPageList.length === this.options.length
    }
  },
  methods: {
    clearUpload () {
      this.$refs.upload.clearFiles()
    },
    setDialogWidth () {
      var val = document.body.clientWidth
      if (val < 968) {
        this.dialogWidth = val
      } else {
        this.dialogWidth = 968
      }
      this.setPdfDivHeight()
    },
    setPdfDivHeight () {
      if (this.dialogWidth >= 1100) {
        let dialogHeight = document.body.clientHeight - 185
        if (dialogHeight < 400) {
          dialogHeight = 400
        }
        this.pdfDivHeight = dialogHeight
      }
    },
    handleFileChange (file, fList) {
      this.clearPdf()
      this.loading = true
      this.$nextTick(t => {
        let pdfObj = { file: file, page: 0 }
        this.selectAll = true
        this.pageRotate = 0
        let URL = window.URL || window.webkitURL
        let fileData = URL.createObjectURL(file.raw)
        pdf.createLoadingTask(fileData).promise.then(pdf => {
          pdfObj.page = pdf.numPages
          this.pdfList.push(pdfObj)
          if (fList.length === this.pdfList.length) {
            this.setPdfTotalPage()
            this.loading = false
          }
        })
      })
    },
    clearPdf (index) {
      this.pdfList = []
      this.pickPageList = []
      this.fileData = null
      this.scale = 90
      this.pageNum = 1
      this.pageIndex = 1
      this.curPageNum = 1
      this.pageTotalNum = 0
      this.loadedRatio = 10
      this.options = []
    },
    closeDialog (needRefresh) {
      this.clearPdf()
      this.$emit('closeDialog', needRefresh)
    },
    setPdfTotalPage () {
      let num = 0
      let index = 0
      this.options = []
      for (let i = 0; i < this.pdfList.length; i++) {
        let pdf = this.pdfList[i]
        num += pdf.page
        for (let j = 1; j <= pdf.page; j++) {
          let value = this.pdfList.length > 1 ? j + ' - ' + pdf.file.name : j
          index += 1
          this.options.push({ key: i + ',' + j, value: value, index: index, checked: false, rotation: 0 })
        }
      }

      let firstFile = this.pdfList[0].file
      this.currentFile = firstFile
      this.fileName = firstFile.name
      this.fileData = URL.createObjectURL(firstFile.raw)

      this.pageTotalNum = num
      if (this.pageTotalNum > 1) {
        this.scale = 90
        this.pageCubeWidth = '50%'
      } else {
        this.scale = 70
        this.pageCubeWidth = '100%'
      }

      if (this.selectAll) {
        for (let option of this.options) {
          option.checked = true
          this.pickPageList.push(option)
        }
      }
    },
    updatePdf (page) {
      this.pageNum = page
      let curPage = this.options.find(q => q.index === page)
      let indexPage = curPage.key.split(',')
      let index = indexPage[0]
      this.pageIndex = parseInt(indexPage[1])
      if (this.currentFile !== this.pdfList[index].file) {
        this.currentFile = this.pdfList[index].file
        this.fileName = this.currentFile.name
        this.fileData = URL.createObjectURL(this.currentFile.raw)
      }
      this.scale = 90
      this.pageRotate = curPage.rotation * 90
    },
    prePage () {
      let page = this.pageNum
      if (page > 1) {
        page = page - 1
      }
      this.updatePdf(page)
    },
    nextPage () {
      let page = this.pageNum
      if (page < this.pageTotalNum) {
        page = page + 1
      }
      this.updatePdf(page)
    },
    rotateLeft () {
      this.rotate(false)
    },
    rotateRight () {
      this.rotate(true)
    },
    rotate (isRight) {
      const page = this.pageNum
      let curPage = this.options.find(q => q.index === page)
      let rotation = curPage.rotation
      if (isRight) {
        rotation++
      } else {
        rotation--
      }
      rotation = rotation & 3
      this.pageRotate = rotation * 90
      curPage.rotation = rotation
    },
    removeCanvasHeight () {
      document.querySelector('.pdf-page-div canvas').style.height = 'auto'
    },
    scaleD () {
      this.scale += 5
      this.removeCanvasHeight()
    },
    scaleX () {
      if (this.scale === 20) {
        return
      }
      this.scale -= 5
      this.removeCanvasHeight()
    },
    pageLoaded (e) {
      this.curPageNum = this.pageNum
    },
    pdfError (error) {
      console.error(error)
      Notification({
        type: 'warning',
        title: 'ERROR',
        message: error,
        duration: 3000,
        showClose: false
      })
    },
    checkPageClick () {
      let index = this.pickPageList.findIndex(q => q.index === this.pageNum)
      let option = this.options.find(q => q.index === this.pageNum)
      if (index > -1) {
        option.checked = false
        this.pickPageList.splice(index, 1)
      } else {
        option.checked = true
        this.pickPageList.push(option)
      }
    },
    numberChange (val, index) {
      if (this.curPageNum === null || this.curPageNum.toString().trim() === '' || this.curPageNum < 1) {
        this.curPageNum = 1
      }
      if (this.curPageNum > this.pageTotalNum) {
        this.pageNum = this.pageTotalNum
        this.curPageNum = this.pageTotalNum
      } else {
        this.pageNum = this.curPageNum
      }
      this.updatePdf(this.pageNum)
    },
    onMultiSelect (option) {
      option.checked = true
    },
    onMultiRemove (option) {
      option.checked = false
      this.selectAll = false
    },
    limitText (count) {
      return this.$t('diagramDialog.PagesSelected', [count + 1])
    },
    checkAll () {
      if (this.checkedAll && this.selectAll) {
        this.checkedAll = false
      } else {
        this.checkedAll = true
      }
      if (this.pageTotalNum > 0) {
        this.pickPageList = []
        let that = this
        this.options.forEach(ele => {
          ele.checked = that.checkedAll === true
          if (ele.checked) {
            that.pickPageList.push(ele)
          }
        })
      }
    }
  },
  components: {
    pdf,
    Multiselect
  }
}
</script>

<style scoped lang="scss">
.upload {
  margin-bottom: 10px;
}
.pdf-main-div {
  width: 100%;
  height: 100%;
}
.pdf-dialog {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.pdf-headers {
  width: 100%;
  color: #dcdfe6;
  line-height: 10px;
  height: 30px;
  background-color: #222323;
}

.pdf-headers-p {
  margin-top: 8px;
  font-size: 15px;
  padding-left: 15px;
  padding-top: 10px;
}

.pdf-main {
  overflow-y: auto;
  height: calc(100% - 60px);
  margin-top: 10px;
  .cube-box {
    box-sizing: border-box;
    width: 100%;
    padding: 0 8px;
    float: left;
    overflow: hidden;
    margin-bottom: 16px;
    .pdf-page-box {
      height: auto;
      padding: 8px;
      background-color: #fff;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      .pdf-page-div {
        height: 100%;
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        img {
          height: 100%;
          width: 100%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        .cover {
          width: 100%;
          -webkit-transition: bottom 0.5s;
          transition: bottom 0.5s;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: -100%;
          z-index: 10;
          cursor: pointer;
          i {
            font-size: 36px;
            color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .cover-show {
          bottom: 0;
        }
      }
    }
  }
}
.pdf-main::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  background-color: #f5f5f5;
}
.pdf-main::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.pdf-main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #aaa;
}
.pdf-footers {
  width: 100%;
  color: #dcdfe6;
  line-height: 10px;
  height: 30px;
  background-color: #222323;
}

.footer-ul {
  width: fit-content;
  display: flex;
  margin: 0 auto;
  list-style: none;
  padding-left: 15px;
}

.footer-ul li {
  text-align: center;
  flex: 1;
  padding: 2px 10px 2px 10px;
  cursor: pointer;
}
.footer-ul li.btnClass:hover {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4%;
}
.footer-ul li.btnClass {
  max-width: 29px;
}
.more-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.small-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.up-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}

.down-p {
  margin: 0;
  cursor: pointer;
  font-size: 25px;
}
.page-p {
  margin-top: 8px;
  font-size: 18px;
  input {
    width: 30px;
    line-height: inherit;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    font-family: inherit;
    outline: none;
    text-align: center;
  }
}
.select-pdf-button {
  margin-bottom: 15px;
  label {
    vertical-align: bottom;
  }
}
/deep/.multiselect__tags-wrap {
  display: none;
}
/deep/.multiselect__strong {
  display: none;
}
/deep/.multiselect,
/deep/.multiselect__input,
/deep/.multiselect__single {
  font-size: 14px;
}
</style>
